import StageDenver, { getServerSideProps } from './Boulder';
export default StageDenver;
export { getServerSideProps };
